// @ts-nocheck
import { createFileRoute } from '@tanstack/react-router';
import CustomerZoneHome from '@/PageComponents/CustomerZone/CustomerZoneHome';

function Dashboard() {
  return <CustomerZoneHome />;
}

export default Dashboard;

export const Route = createFileRoute('/_customerzoneLayout/customerzone')({ component: Dashboard });
